import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { selectBillingDate, selectFttbConnectUrl } from "./store";
import { BillingDate } from "../BillingDate";
import { FTTBAccumulators } from "./FTTBAccumulators";
import { FTTBAddress } from "./FTTBAddress";
import { FTTBTariffTitle } from "./FTTBTariffTitle";
import { selectFTTBConnectionBlockData, selectFTTBConnectionBlockPending, selectIsFTTBUser } from "../../store/selectors";
import { Card } from "../../../Card";
import { Skeleton } from "../Skeleton";
var _FTTBTariff = function _FTTBTariff(_ref) {
  var billingDate = _ref.billingDate,
    tariffUrl = _ref.tariffUrl,
    pending = _ref.pending;
  if (pending) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      "data-t-id": "components-FTTBTariff"
    });
  }
  return /*#__PURE__*/React.createElement(Card, {
    color: "primary",
    href: tariffUrl,
    size: "m"
  }, /*#__PURE__*/React.createElement(FTTBTariffTitle, {
    "data-t-id": "components-FTTBTariff"
  }), /*#__PURE__*/React.createElement(FTTBAddress, null), /*#__PURE__*/React.createElement(FTTBAccumulators, null), /*#__PURE__*/React.createElement(BillingDate, {
    billingDate: billingDate,
    isComposeBillingDate: true
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var pending = selectFTTBConnectionBlockPending(state);
  return {
    tariffUrl: selectFttbConnectUrl(state),
    billingDate: selectBillingDate(state),
    pending: pending,
    shouldRender: (!!selectFTTBConnectionBlockData(state) || pending) && selectIsFTTBUser(state)
  };
};
export var FTTBTariff = compose(connect(mapStateToProps), withRenderFlag)(_FTTBTariff);